import { render, staticRenderFns } from "./OES-metadata-widget.vue?vue&type=template&id=0b5defee"
import script from "./OES-metadata-widget.vue?vue&type=script&lang=js"
export * from "./OES-metadata-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports